import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

/*
Custom hook to handle redirecting to alive version if the product is expired.
 */
const useRedirectIfExpired = (isExpiredProduct, productOffers, productId) => {
  const navigate = useNavigate();
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (isExpiredProduct && !hasRedirected.current) {
      const activePdp = productOffers.find((item) => !item.expiredProduct)?.pdp_path;
      if (activePdp) {
        hasRedirected.current = true;
        navigate(activePdp);
      }
    }
  }, [isExpiredProduct, productOffers, navigate]);

  useEffect(() => {
    if (productId && hasRedirected.current) {
      hasRedirected.current = false;
    }
  }, [productId]);
};

export default useRedirectIfExpired;
